// Catches render-time crashes inside its children and shows a recoverable
// error card instead of blanking the whole page. Use around tabs/screens
// so a single component bug doesn't take down the entire app.
//
// Usage:
//   <ErrorBoundary label="Households">
//     <BWMClients />
//   </ErrorBoundary>

import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', this.props.label || '(unlabeled)', error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="bg-rose/5 border border-rose/30 rounded-[4px] p-5 text-[12px]">
        <div className="font-bold text-rose mb-1">Something went wrong{this.props.label ? ` in ${this.props.label}` : ''}</div>
        <div className="text-[#444] mb-2">
          The page crashed but the rest of the app is still running. Switch tabs or click Retry to try again. If this keeps happening, screenshot the message below and send it over.
        </div>
        <pre className="bg-white border border-rose/20 rounded-[3px] p-2 overflow-auto max-h-40 text-[10px] text-[#666]">
          {this.state.error?.message || String(this.state.error)}
          {this.state.error?.stack && `\n\n${this.state.error.stack.split('\n').slice(0, 8).join('\n')}`}
        </pre>
        <button
          onClick={this.reset}
          className="mt-3 px-3 py-1.5 text-[11px] font-bold text-white bg-bullogic-blue rounded-[3px] hover:bg-bullogic-blue/90"
        >
          Retry
        </button>
      </div>
    );
  }
}
